import axios from '@/utils/api'

const actions = {

  async getByFilter ({ commit }, { dados }) {
    return axios({
      method: 'post',
      url: 'analise-georreferenciamento/find-by-filter',
      data: dados
    })
  },
  async getCadastroGeo ({ commit }, id) {
    return axios({
      method: 'get',
      url: `analise-georreferenciamento/find-cadastro/${id}`
    })
  },
  async salvar ({ commit }, data) {
    return axios({
      method: 'post',
      url: 'analise-georreferenciamento/salvar',
      data
    })
  },
  async removerAnalise ({ commit }, id) {
    return axios({
      method: 'delete',
      url: `analise-georreferenciamento/remove-cadastro/${id}`
    })
  },
  async vincular ({ commit }, { id, numeroRecibo }) {
    return axios({
      method: 'post',
      url: `analise-georreferenciamento/vincular-recibo/${id}/${numeroRecibo}`
    })
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/analiseGeo.js